// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Headers
 */
/*
  Base Sizing
 */
/*
  Colors
 */
/*
  Border Radii Sizes
 */
/*
  Shadows
 */
/*
  Global Styles
 */
html {
  font-size: 10px;
}

/**
 * COODE Header Colors
 */
.form-divider {
  background-color: #d6d6d6;
  height: 0.16rem;
  margin: 2.4rem 2.4rem 0;
}
.pui-collapsible__content {
  background-color: white;
}
.files-section {
  margin-top: 0.8rem;
}
.error-inline-notification {
  margin-top: 1.6rem;
}
.error-inline-notification-approval-form {
  margin-bottom: 2.56rem;
}
.error-inline-notification-notifiable-users {
  margin-bottom: 1vh;
}
.extra-risk-id-field {
  margin-top: 0.8rem;
}
.extra-risk-id-button {
  margin-top: 1.6rem;
}
.collapsible-padding {
  padding: 20px;
}
.collapsible-pb {
  padding-bottom: 3.2rem;
}
.collapsible-bg {
  background-color: white;
}
.add-budget-compensation-pb {
  padding-left: 1.6rem;
  padding-bottom: 1.92rem;
}
.action-row-p {
  padding-top: 2.4rem;
}
.flex-buttons {
  display: flex;
  gap: 0.8rem;
}
.cr-field-popover {
  display: flex;
  flex-direction: column;
  gap: 1.28rem;
  margin-top: -1.6rem;
}
.cr-field-popover__header {
  font-weight: bold;
}
.cr-field-popover__field--title {
  font-weight: bold;
}
.cr-field-popover__list {
  margin-left: 1.6rem;
  margin-bottom: 0;
}
.cr-field-popover__list li {
  font-size: 1.36rem;
  line-height: 2;
  list-style: disc inside none;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
